import { saveAs } from "file-saver";
import moment from "moment";
import React, { useEffect, useMemo, useState } from "react";
import {
  useLocation,
  useNavigate,
  useParams,
  useSearchParams,
} from "react-router-dom";
import { toast } from "react-toastify";
import ExcelApi from "../../../api/excel.api";
import Table from "../../../component/atoms/layout/table/table";
import GoBack from "../../../component/molecules/goBack";
import TableTab02 from "../../../component/molecules/tableTab02";
import Modal from "../../../component/templates/Modal";
import { errorHandler } from "../../../util/errorHandler";
import { toastMsg } from "../../../util/toastMsg";
import ReviewModal from "../_component/reviewModal";
import DetailBtn from "./../../../component/atoms/button/detailBtn";
import ExcelBtn from "./../../../component/atoms/button/excelBtn";
import TableDelBtn from "./../../../component/atoms/button/tableDelBtn";
import Checkbox from "./../../../component/atoms/input/checkbox";
import SearchBar from "./../../../component/atoms/input/searchBar";
import MainLayout from "./../../../component/atoms/layout/mainLayout";
import TableLayout from "./../../../component/atoms/layout/table/tableLayout";
import TableSearchBtn from "./../../../component/atoms/layout/table/tableSearchBtn";
import TableTop from "./../../../component/atoms/layout/table/tableTop";
import Td from "./../../../component/atoms/layout/table/td";
import Th from "./../../../component/atoms/layout/table/th";
import Tr from "./../../../component/atoms/layout/table/tr";
import TableText from "./../../../component/atoms/text/table/tableText";
import Pagination from "./../../../component/molecules/pagination";
import TableCount from "./../../../component/molecules/tableCount";
import Header from "./../../../component/organisms/header";
import Sidebar from "./../../../component/organisms/sidebar";
import { route } from "./../../../router/route";
import { modalMsg } from "./../../../util/modalMsg";
import ReviewApi from "../../../api/review.api";
import DelBtn from "../../../component/atoms/button/delBtn";

const ConsultingReview = () => {
  let { id } = useParams();

  const tabList = [
    {
      title: "컨설팅 상세",
      link: `${route.consulting_detail_info}/${id}`,
      originLink: route.consulting_detail_info,
    },
    {
      title: "컨설팅 후기 관리",
      link: `${route.consulting_detail_review}/${id}`,
      originLink: route.consulting_detail_review,
    },
  ];

  const navigate = useNavigate();
  const location = useLocation();
  const [searchParams, setSearchParams] = useSearchParams();

  const page = useMemo(() => {
    return searchParams.get("page") ? searchParams.get("page") : 1;
  }, [searchParams]);

  // ----------------------------------- //
  // ---------- 마운트가 되면 ---------- //
  // --------------------------------- //
  useEffect(() => {
    setKeyword(searchParams.get("keyword") ? searchParams.get("keyword") : "");
    getReviewList();
  }, [location]);

  const [reviewList, setReviewList] = useState([]);
  const [keyword, setKeyword] = useState("");

  const getReviewList = async () => {
    try {
      const data = {
        keyword: searchParams.get("keyword"),
        page: searchParams.get("page"),
        size: pagination.size,
        consultingMerchId: id,
      };
      let responseData = (await ReviewApi.getList(data)).data.data;
      setReviewList(
        responseData.content.map((item) => {
          return {
            ...item,
            checked: false,
          };
        })
      );
      setPagination({
        ...pagination,
        totalCount: responseData.totalCount ? responseData.totalCount : 0,
        totalPages: Math.ceil(responseData.totalCount / pagination.size),
      });
    } catch (error) {
      errorHandler(error);
    }
  };

  const [pagination, setPagination] = useState({
    size: 10, // 한 페이지에 표시될 게시글 수
    rangeSize: 5, // 하단 페이지 사이즈
    totalCount: 1,
    totalPages: 1,
  });

  const isAllCheck = useMemo(() => {
    const checkedList = reviewList.filter((item) => item.checked);
    return checkedList.length !== 0 && checkedList.length === reviewList.length;
  }, [reviewList]);

  const [subTitle, setSubTitle] = useState("항목");

  // ----- 삭제
  const [delIdList, setDelIdList] = useState([]);
  const [deleteModalOpen, setDeleteModalOpen] = useState(false);

  const deleteFunc = async () => {
    try {
      await Promise.all(delIdList.map((reviewId) => ReviewApi.delete(reviewId)));
      toast(toastMsg.delete);
      setDeleteModalOpen(false);
      setDelIdList([]);
      getReviewList();
    } catch (error) {
      errorHandler(error);
    }
  };

  const [selectedData, setSelectedData] = useState({});
  const [detailModalOpen, setDetailModalOpen] = useState(false);

  //------------엑셀 생성
  const downloadExcel = async (excelData) => {
    const Excel = require("exceljs");
    const workbook = new Excel.Workbook();
    workbook.addWorksheet("Sheet One");
    const sheetOne = workbook.getWorksheet("Sheet One");

    sheetOne.columns = [
      { header: "아이디", key: "account", width: 40 },
      { header: "수강후기 제목", key: "title", width: 40 },
      { header: "별점", key: "score", width: 40 },
      { header: "작성일", key: "createdAt", width: 40 },
    ];

    excelData.map((item) => {
      // 행 추가
      sheetOne.addRow(item);
    });
    const buffer = await workbook.xlsx.writeBuffer();
    saveAs(new Blob([buffer]), "컨설팅 후기 관리.xlsx");
  };

  const getExcelAll = async () => {
    try {
      const excelArr = [];
      const response = (
        await ExcelApi.GetConsultingReviewExcel({
          ids: [],
          allFlag: true,
          consultingMerchId: id,
          keyword: searchParams.get("keyword"),
        })
      ).data.data.content;

      response.map((item) => {
        const account = item.member?.account;
        const createDate = moment(item.createdAt).format("YYYY/MM/DD");
        excelArr.unshift({
          ...item,
          account: account,
          createdAt: createDate,
        });
      });

      downloadExcel(excelArr);
    } catch (error) {
      errorHandler(error);
    }
  };

  const getExcelChecked = async () => {
    const filter = reviewList.filter((item) => item.checked);
    if (filter.length <= 0) {
      return toast("항목을 선택해주세요");
    }

    try {
      const excelArr = [];
      const response = (
        await ExcelApi.GetConsultingReviewExcel({
          ids: filter.map((item) => item.id),
          allFlag: false,
          consultingMerchId: id,
          keyword: searchParams.get("keyword"),
        })
      ).data.data.content;

      response.map((item) => {
        const account = item.member?.account;
        const createDate = moment(item.createdAt).format("YYYY/MM/DD");
        excelArr.unshift({
          ...item,
          account: account,
          createdAt: createDate,
        });
      });

      downloadExcel(excelArr);
    } catch (error) {
      errorHandler(error);
    }
  };
  //------------액셀 부분 끝

  const [saveModalOpen, setSaveModalOpen] = useState(false);

  const setMainFlagFunc = async () => {
    try {
      await ReviewApi.updateMainFlagTrue({ ids: delIdList });
      toast(toastMsg.update);
      setSaveModalOpen(false);
      setDelIdList([]);
      getReviewList();
    } catch (error) {
      errorHandler(error);
    }
  };

  return (
    <>
      <Header />
      <MainLayout>
        <Sidebar />
        <TableLayout>
          <GoBack />
          <TableTab02 list={tabList} style={{ margin: "20px 0" }} />
          <TableTop>
            <TableCount text={subTitle} count={pagination.totalCount} />
            <TableSearchBtn>
              <SearchBar
                value={keyword}
                onChange={(e) => {
                  setKeyword(e.target.value);
                }}
                onKeyDown={(e) => {
                  if (e.key === "Enter") {
                    navigate(
                      `${route.consulting_detail_review}/${id}?page=1&keyword=${encodeURIComponent(
                        keyword
                      )}`,
                      {
                        replace: true,
                      }
                    );
                  }
                }}
                onClick={() => {
                  navigate(
                    `${route.consulting_detail_review}/${id}?page=1&keyword=${encodeURIComponent(
                      keyword
                    )}`,
                    {
                      replace: true,
                    }
                  );
                }}
              />
              <DelBtn
                text={"선택항목 대표 설정"}
                onClick={() => {
                  const delList = reviewList.filter((item) => item.checked);
                  if (delList.length <= 0) {
                    return;
                  }
                  setDelIdList(delList.map((item) => item.id));
                  setSaveModalOpen(true);
                }}
              />
              <ExcelBtn
                onSelectClick={getExcelChecked}
                onAllClick={getExcelAll}
              />
            </TableSearchBtn>
          </TableTop>
          <Table>
            <colgroup>
              {/* 체크박스 영역 */}
              <col width="90px" />
              {/* 아이디 */}
              <col width="137px" />
              {/* 제목 */}
              <col width="296px" />
              {/* 대표 설정 */}
              <col width="75px" />
              {/* 별점 */}
              <col width="71px" />
              {/* 작성일 */}
              <col width="140px" />
              {/* 후기 삭제 */}
              <col width="91px" />
              {/* 상세보기 */}
              <col width="78px" />
            </colgroup>
            <thead>
              <Tr style={{ height: "40px", background: "#f2f4f5" }}>
                <Th style={{ paddingLeft: "20px" }}>
                  <Checkbox
                    checked={isAllCheck}
                    onChange={(e) => {
                      if (e.target.checked) {
                        setReviewList(
                          reviewList.map((item) => {
                            return {
                              ...item,
                              checked: true,
                            };
                          })
                        );
                      } else {
                        setReviewList(
                          reviewList.map((item) => {
                            return {
                              ...item,
                              checked: false,
                            };
                          })
                        );
                      }
                    }}
                  />
                </Th>
                <Th>
                  <TableText>아이디</TableText>
                </Th>
                <Th>
                  <TableText>제목</TableText>
                </Th>
                <Th>
                  <TableText style={{ textAlign: "center" }}>대표</TableText>
                </Th>
                <Th>
                  <TableText>별점</TableText>
                </Th>
                <Th>
                  <TableText>작성일</TableText>
                </Th>
                <Th>
                  <TableText>후기 삭제</TableText>
                </Th>
                <Th>
                  <TableText>상세보기</TableText>
                </Th>
              </Tr>
            </thead>
            <tbody>
              {reviewList.map((item, index) => {
                return (
                  <Tr
                    key={index}
                    style={{ height: "59px", background: "#fff" }}
                  >
                    <Td style={{ paddingLeft: "20px" }}>
                      <Checkbox
                        checked={item.checked}
                        onChange={() => {
                          item.checked = !item.checked;
                          setReviewList([...reviewList]);
                        }}
                      />
                    </Td>
                    <Td>
                      <TableText>{item.member?.account}</TableText>
                    </Td>
                    <Td>
                      <TableText>{item.title}</TableText>
                    </Td>
                    <Td>
                      <TableText
                        style={{ textAlign: "center", color: "#27BEFF" }}
                      >
                        {item.mainFlag ? "대표" : ""}
                      </TableText>
                    </Td>
                    <Td>
                      <TableText>{item.score}</TableText>
                    </Td>
                    <Td>
                      <TableText>
                        {moment(item.createdAt).format("YYYY/MM/DD")}
                      </TableText>
                    </Td>
                    <Td>
                      <TableDelBtn
                        style={{ marginLeft: "6px" }}
                        onClick={() => {
                          setReviewList([...reviewList]);
                          const delList = [item];
                          setDelIdList(delList.map((item) => item.id));
                          setDeleteModalOpen(true);
                        }}
                      />
                    </Td>
                    <Td>
                      <DetailBtn
                        onClick={() => {
                          setSelectedData(item);
                          setDetailModalOpen(true);
                        }}
                      />
                    </Td>
                  </Tr>
                );
              })}
            </tbody>
          </Table>
          <Pagination
            route={route.consulting_detail_review}
            queryString={`keyword=${encodeURIComponent(
              searchParams.get("keyword") || ""
            )}`}
            currentPage={page}
            totalPages={pagination.totalPages}
            rangeSize={pagination.rangeSize}
          />
        </TableLayout>
      </MainLayout>

      {saveModalOpen ? (
        <Modal
          title={"대표로 설정하시겠습니까?"}
          text={
            <>
              대표 후기는 메인페이지에 노출되며,
              <br />
              금융 스터디와 유료 강의를 통합하여
              <br />
              최대 6개까지 지정 가능합니다.
            </>
          }
          setModalOpen={setSaveModalOpen}
          onClick={() => {
            setMainFlagFunc();
          }}
        />
      ) : null}

      {deleteModalOpen ? (
        <Modal
          negative
          title={modalMsg.delete?.title}
          text={modalMsg.delete?.content}
          btnTitle={"삭제하기"}
          setModalOpen={setDeleteModalOpen}
          onClick={() => {
            deleteFunc();
          }}
        />
      ) : null}

      {detailModalOpen ? (
        <ReviewModal
          data={selectedData}
          setData={setSelectedData}
          list={reviewList}
          setList={setReviewList}
          setModalOpen={setDetailModalOpen}
        />
      ) : (
        ""
      )}
    </>
  );
};

export default ConsultingReview;
